import React, { Fragment, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { getAppImage } from 'helpers';
import { useClient } from 'hooks';
import { APP_IMAGES } from 'constants/index';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      textAlign: 'center',
    },
    image: {
      width: '80%',
    },
    subHeader: {
      fontSize: theme.typography.pxToRem(20),
    },
    bodyText: {
      margin: `${theme.spacing(3)}px auto 0`,
      textAlign: 'center',
      maxWidth: '90%',
    },
  });

const Main: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const { t } = useTranslation();
  const client = useClient();

  return (
    <Fragment>
      <Grid container justify="center" className={classes.container}>
        <Grid item>
          <img className={classes.image} {...getAppImage(APP_IMAGES.Welcome2)} />
        </Grid>
        <Grid item>
          <div className={classes.bodyText}>
            <Typography gutterBottom variant="h2">
              {t('onboarding:bodyHeader', { name: client.title })}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default withStyles(styles)(Main);
